// Brief interfaces for list view
export interface BriefCommercialEvaluation {
  id: string;
  flightDate: string;
  carrierCode: string;
  flightNumber: string;
  departureAirport: string;
  arrivalAirport: string;
  aircraftRegistration: string;
  supervisorEmployeeId: string;
  evaluatedEmployeeId: string;
  evaluatedEmployeeName?: string;
  evaluatedEmployeeLastName?: string;
  receptionDate: string;
}

export interface BriefFlightEvaluation {
  id: string;
  flightDate: string;
  carrierCode: string;
  flightNumber: string;
  departureAirport: string;
  arrivalAirport: string;
  aircraftRegistration: string;
  purserEmployeeId: string;
  purserEmployeeName?: string;
  receptionDate: string;
}

// Filter criteria for evaluations
export interface EvaluationCriteria {
  offset: number;
  limit: number;
  flightSince?: string;
  flightUntil?: string;
  carrierCode?: string;
  flightNumber?: string;
  airportFrom?: string;
  airportTo?: string;
  aircraftRegistration?: string;
  supervisorEmployeeId?: string; // Commercial only
  evaluatedEmployeeId?: string; // Commercial only
  purserEmployeeId?: string; // Flight only
  receptionSince?: string;
  receptionUntil?: string;
  sortField?: string;
  sortOrder?: 'asc' | 'desc';
}

export const emptyEvaluationCriteria: EvaluationCriteria = {
  offset: 0,
  limit: 10,
};
